//@ts-check
import {useState, useEffect} from 'react';
import {debounce} from 'lodash';

const getSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

/**
 * Watch window size as it changes
 * @returns {{width: number, height: number}}
 */
const useWindowSize = (debounceMs = 100) => {
  const [windowSize, setWindowSize] = useState(getSize);
  useEffect(() => {
    const handleResize = debounce(() => setWindowSize(getSize()), debounceMs, {leading: true});
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};

export default useWindowSize;